import { makeStyles } from 'makeStyles';
import { MAIN, MAIN_ACTIVE } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  goBackTypography: {
    fontWeight: 600,
    fontSize: 15,
    marginBottom: 20,
    padding: 0,
    '&:hover': {
      cursor: 'pointer',
      color: MAIN_ACTIVE,
      textDecoration: 'underline',
      '& svg > path': {
        stroke: `${MAIN_ACTIVE}!important`,
      },
    },
  },
  arrowGoBack: {
    height: '12px!important',
    '& > path': {
      stroke: MAIN,
    },
  },
  bold: {
    fontWeight: 'bold',
  },
  headerPaper: {
    marginBottom: 20,
    padding: '25px 30px',
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    overflow: 'hidden',
  },
  teamsPanelInfo: {
    flexWrap: 'nowrap',
    gap: theme.spacing(3),
  },
  teamsPanelActions: {
    gap: theme.spacing(1.5),
    width: 'initial',
  },
  tablePaperTitle: {
    marginBottom: theme.spacing(2),
  },
  flexGrow: {
    flexGrow: 1,
  },
  teamDetail: {
    gap: theme.spacing(3),
    maxWidth: '1000px',
  },
}));
